<template>
    <cadastro-simples-list
        endpoint="tipo-passe"
        rota-base="/admin/tipo-passe"
        titulo="TIPOS DE PASSE"
        titulo-singular="Tipo de Passe"
        :colunas-extras="[{ campo: 'descricao', label: 'Descrição' }]">
    </cadastro-simples-list>
</template>
<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
